import styles from './Input.module.scss';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  placeholder: string;
  type: string;
  id: string;
  autoComplete?: string;
}

export function Input({ label, placeholder, type, id, ...props }: InputProps) {
  const randomName = `input-${Math.random().toString(36).substring(2, 15)}`;

  return (
    <div className={styles.formGroup}>
      <input
        type={type}
        id={id}
        name={randomName}
        placeholder={placeholder}
        autoComplete="new-password"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        autoSave="off"
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
}
